<template>
  <!-- This example requires Tailwind CSS v2.0+ -->
  <div class="fixed z-50 inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>

      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
      <div class="inline-block align-middle bg-white rounded-xl text-left overflow-hidden shadow-2xl transform transition-all w-full sm:w-11/12 md:w-2/3 lg:w-1/2 my-8">
        <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">

          <div class="flex flex-col bg-white rounded p-2 sm:p-6">
            <div class="flex items-center justify-between mb-8 pb-4 border-b border-gray-100">
              <h3 class="text-lg leading-6 font-semibold text-gray-900" id="modal-title"> Change Device Label for DEVID: {{mac_address}} </h3>
              <button type="button" class="text-gray-400 hover:text-gray-600 transition-colors" @click="cancelTransaction" aria-label="Close">
                <i class="fas fa-times text-lg"></i>
              </button>
            </div>

            <div class="flex flex-col sm:flex-row sm:items-center justify-between mt-4">
              <p class="text-sm font-medium text-expressgray sm:w-1/3">Enter New Label </p>
              <div class="flex space-x-2 sm:w-2/3 justify-between mt-1 sm:mt-0">
                <input  type="text"  placeholder="Example (My Iphone 6)" class="border border-gray-200 rounded-lg p-2.5 w-full text-sm focus:outline-none focus:border-express" v-model.trim="form.new_label"/>
              </div>
            </div>



            <div class="flex flex-col sm:flex-row items-center justify-end gap-3 mt-8 pt-4 border-t border-gray-100">
              <button type="button" class="w-full sm:w-auto inline-flex justify-center rounded-lg px-5 py-2.5 bg-express text-sm font-medium text-white hover:bg-expressbutton transition-colors" @click="completeTransaction">Update Device Label</button>
              <button type="button" class="w-full sm:w-auto inline-flex justify-center rounded-lg border border-gray-200 px-5 py-2.5 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors" @click="cancelTransaction">Close</button>
            </div>




          </div>




        </div>

      </div>
    </div>
  </div>
</template>

<script>



export default {
  name: "add_retailer_model",
  props: ['mac_address'],
  emits:["completeTransaction","cancelTransaction"],
  data(){
    return{
      form:{
        new_label:'',
      },


    }
  },

  methods: {
    resetForm: function(){
      for (var item in this.form)
      {
        this.form[item] = null
      }
},
    completeTransaction()  {

      if (this.form.new_label.length > 1 && this.form.new_label  !== '')
       {
        this.$emit('completeTransaction', [this.form,this.mac_address])
      }else{
          //console.log('missing fields')
          this.$toast.error(`Error Missing fields: Device Name Required`)
      }
    },
    cancelTransaction: function (e) {
      this.$emit('cancelTransaction')
      this.resetForm()
    }
  }


}
</script>

<style scoped>

</style>
